export default __webpack_public_path__ + "media/images/user_photos/150-0755a5bd3f9adc50b93e1301fd07c042.jpg";